import { render, staticRenderFns } from "./ProjectBookingStatus.vue?vue&type=template&id=3ae4e010&"
import script from "./ProjectBookingStatus.vue?vue&type=script&lang=js&"
export * from "./ProjectBookingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports